var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import { Module, ModuleProgress, ModuleGrid, ModuleMedia, ModuleContent, ModuleHeader, ModuleFooter, ModuleBody, ModuleColor, ModuleTitle, ModuleLabel, ModuleDescription, ModuleLink, Buttongroup, Button, NavSettings, NavTabs, NavAction, NavSortable } from "../";

import "./LayoutModule.scss";

import ImageEditFocalpoint from '../Media/ImageEditFocalpoint';
import ImageEditCropdata from '../Media/ImageEditCropdata';

var templates = {
    "focalpoint": ImageEditFocalpoint,
    "cropdata": ImageEditCropdata
};

var LayoutModuleEdit = (_temp2 = _class = function (_Component) {
    _inherits(LayoutModuleEdit, _Component);

    function LayoutModuleEdit() {
        var _temp, _this, _ret;

        _classCallCheck(this, LayoutModuleEdit);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onEditProperty = function (name, value) {
            var formData = _this.props.formData;


            if (_this.props.onChange) {
                var _extends2;

                _this.props.onChange(_extends({}, formData, (_extends2 = {}, _extends2[name] = value, _extends2)));
            }
        }, _this.onEditFocalpoint = function (focalpoint) {
            _this.onEditProperty("focalpoint", focalpoint);
        }, _this.onEditCropdata = function (cropdata) {
            _this.onEditProperty("cropdata", cropdata);
        }, _this.renderAction = function () {
            var _this$props = _this.props,
                editable = _this$props.editable,
                editing = _this$props.editing,
                onSave = _this$props.onSave;


            if (editable && editing) {

                return React.createElement(NavAction, { buttonType: "secondary", button: { title: "Lagre", onClick: onSave }, align: "right" });
            }

            return false;
        }, _this.renderHeader = function () {
            var _this$props2 = _this.props,
                collapsible = _this$props2.collapsible,
                editable = _this$props2.editable,
                menu = _this$props2.menu,
                color = _this$props2.color,
                title = _this$props2.title,
                onToggle = _this$props2.onToggle;


            if (menu) {

                return React.createElement(
                    ModuleHeader,
                    null,
                    React.createElement(
                        ModuleGrid,
                        null,
                        React.createElement(
                            ModuleContent,
                            null,
                            React.createElement(NavTabs, { tabs: menu }),
                            _this.renderAction()
                        )
                    )
                );
            }

            return React.createElement(
                ModuleHeader,
                null,
                React.createElement(
                    ModuleGrid,
                    null,
                    React.createElement(
                        ModuleContent,
                        null,
                        React.createElement(ModuleColor, { color: color }),
                        React.createElement(ModuleTitle, { title: title }),
                        _this.renderAction()
                    )
                )
            );
        }, _this.renderBody = function () {
            var _this$props3 = _this.props,
                expandName = _this$props3.expandName,
                menu = _this$props3.menu,
                media = _this$props3.media,
                formData = _this$props3.formData;


            var template = void 0;

            if (expandName) {
                template = expandName;
            } else if (menu && menu.length) {
                template = menu[0].name;
            }

            // media templates

            if (media && templates[template]) {
                var MediaEditTemplate = templates[template];

                return React.createElement(
                    ModuleBody,
                    null,
                    React.createElement(ModuleMedia, _this.props),
                    React.createElement(
                        ModuleContent,
                        null,
                        React.createElement(MediaEditTemplate, _extends({}, formData, { media: media, onFocalpoint: _this.onEditFocalpoint, onCrop: _this.onEditCropdata }))
                    )
                );
            }

            // default

            return React.createElement(
                ModuleBody,
                null,
                React.createElement(ModuleMedia, _this.props),
                React.createElement(
                    ModuleContent,
                    null,
                    _this.props.children
                )
            );
        }, _this.renderButton = function (button, index) {

            return React.createElement(Button, _extends({ buttonType: "secondary" }, button, { key: index }));
        }, _this.renderFooter = function () {
            var buttons = _this.props.buttons;


            if (!buttons) {
                return false;
            }

            return React.createElement(
                ModuleFooter,
                null,
                React.createElement(
                    Buttongroup,
                    { type: "inline" },
                    buttons.map(_this.renderButton)
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    LayoutModuleEdit.prototype.render = function render() {
        var _props = this.props,
            editable = _props.editable,
            editing = _props.editing,
            collapsible = _props.collapsible,
            expanded = _props.expanded,
            settings = _props.settings,
            style = _props.style,
            status = _props.status,
            onEdit = _props.onEdit;


        if (editable && editing || !editable && collapsible && expanded) {

            return React.createElement(
                Module,
                _extends({}, this.props, { moduleLayout: "edit", expanded: true }),
                this.renderHeader(),
                this.renderBody(),
                this.renderFooter()
            );
        }

        return React.createElement(
            Module,
            { moduleLayout: "edit", url: false, expanded: false, status: status, style: style },
            React.createElement(NavSortable, this.props),
            React.createElement(
                ModuleLink,
                { onClick: onEdit },
                React.createElement(
                    ModuleGrid,
                    null,
                    React.createElement(ModuleProgress, this.props),
                    React.createElement(ModuleMedia, this.props),
                    React.createElement(
                        ModuleContent,
                        null,
                        React.createElement(
                            ModuleHeader,
                            null,
                            React.createElement(ModuleColor, this.props),
                            React.createElement(ModuleTitle, this.props),
                            " ",
                            ' ',
                            React.createElement(ModuleDescription, this.props)
                        )
                    )
                )
            ),
            React.createElement(NavSettings, { settings: settings })
        );
    };

    return LayoutModuleEdit;
}(Component), _class.defaultProps = {
    id: undefined,
    collapsible: true,
    expanded: false,
    editable: false,
    editing: false,
    menu: false
}, _temp2);


export default LayoutModuleEdit;